import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { ElementTypes, ExpandComponent } from '@fcom/common';
import { AppState, ConfigService } from '@fcom/core';
import { orderData } from '@fcom/common-booking';
import { finShare, snapshot } from '@fcom/rx';
import { GaContext } from '@fcom/common/interfaces/gtm.interface';
import { FinnairOrder } from '@fcom/dapi/api/models';

import { MmbStage } from '../../enums';
import { MmbNavigationItem } from '../../interfaces';
import { getLoading, getStage } from '../../store';
import { getMmbNavigationItems } from '../../utils/routing.utils';
import { ManageBookingService } from '../../services';

@Component({
  selector: 'fin-mmb-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageBookingSideNavigationComponent implements OnInit {
  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;

  navigationItems$: Observable<MmbNavigationItem[]>;
  stage$: Observable<MmbStage>;
  activeMenuItemTitle$: Observable<string>;
  orderLoading$: Observable<boolean>;
  enableRefetchOrder: boolean;

  constructor(
    private store$: Store<AppState>,
    private languageService: LanguageService,
    private mmbService: ManageBookingService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.enableRefetchOrder = this.configService.cfg.enableRefetchOrder;
    this.orderLoading$ = this.store$.pipe(getLoading());
    this.stage$ = this.store$.pipe(getStage());
    this.navigationItems$ = this.store$.pipe(orderData()).pipe(
      map((order) =>
        getMmbNavigationItems(order).map((item) => {
          return {
            ...item,
            path: `${this.languageService.langValue}/${item.path}`,
          };
        })
      ),
      finShare()
    );

    this.activeMenuItemTitle$ = combineLatest([this.stage$, this.navigationItems$]).pipe(
      map(
        ([stage, navigationItems]) => navigationItems.find((item) => item.targetStage === stage)?.translationKey ?? ''
      )
    );
  }

  toggleDetails(expandComponent: ExpandComponent): void {
    expandComponent.toggleDetails();
  }

  refetchOrder(event: Event): void {
    event.preventDefault();
    const order: FinnairOrder = snapshot(this.store$.pipe(orderData()));
    this.mmbService.getOrderWithIdAndHash(order.id, order.hash);
  }
}
